import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ViewTopBar from "../common_components/viewChanger";
import BottomBar from "../common_components/bottom_bar.component";
import { Link, Redirect } from "react-router-dom";
import config from "../../config";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import logo from "../../assets/img/cw_logo.png";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  root: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text_title: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "500",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: 210,
    borderColor: "#F6277F",
    borderWidth: 40,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  signin_text: {
    color: "#F6277F",
    fontFamily: "Open Sans",
    fontWeight: "600",
    textShadowColor: "rgba(0, 0, 0, 0.75)",
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 10,
  },
  join_text: {
    color: "#F6277F",
    fontWeight: "600",
    fontFamily: "Open Sans",
    textTransform: "none",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  new_text: {
    color: "#000",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  progress_color: {
    color: "#FFF",
  },
});

class LogIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      mobileView: false,
      open: false,
      textDisable: false,
    };
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    sessionStorage.clear();
    window.removeEventListener("resize", this.resize.bind(this));
  }

  componentDidMount() {
    document.title = "LogIn | CanaWho";
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    let currentHideNav = window.innerWidth <= 760;
    // console.log(currentHideNav);
    if (currentHideNav) {
      this.setState({ open: true, textDisable: true });
    } else {
      this.setState({ open: false, textDisable: false });
    }
    if (currentHideNav !== this.state.mobileView) {
      this.setState({ mobileView: currentHideNav });
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  submitForm() {
    const { email, password } = this.state;
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email && password) {
      if (!email.match(mailformat)) {
        this.setState({ email_err: true });
      } else {
        this.setState({ loading: true });
        const obj = {
          email: email.toLowerCase(),
          password: password,
        };
        axios
          .post(BACKEND_URL + `/login/unified`, obj)
          .then((res) => {
            // console.log(res);
            this.setState({ loading: false });
            this.loginSuccess(res.data);
          })
          .catch((error) => {
            this.setState({ loading: false });
            // Error 😨
            if (error.response) {
              alert("Sign In failed - " + error.response.data.message);
              // console.log(error.response.data);
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else if (error.request) {
              alert("The server is down, we are fixing it right now.");
              // console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              alert("Error - " + error.message);
              // console.log("Error", error.message);
            }
            // console.log(error.config);
          });
      }
    } else {
      alert("Please enter the required fields");
    }
  }

  loginSuccess = (data) => {
    // console.log(data.brand_id);
    axios.defaults.headers.common["Authorization"] = data.token;
    if (data.is_admin) {
      this.props.history.push({ pathname: "/admin", token: data.token });
    } else {
      sessionStorage.setItem("brand_id", data.brand_id);
      sessionStorage.setItem("token", data.token);
      if (data) {
        this.props.history.push({ pathname: "/company/subscription" });
      } else {
        this.props.history.push({ pathname: "/company/leaflibrary" });
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { email_err, loading } = this.state;

    return (
      <div className={classes.root}>
        <ViewTopBar />
        <Grid container direction="column" alignItems="center" justify="center">
          <h1 class={classes.text_title}>
            <u>Company Community</u>
          </h1>
          <Container style={{ marginBottom: 40 }}>
            <CssBaseline />
            <div className={classes.paper}>
              <Typography
                component="h1"
                variant="h5"
                className={classes.signin_text}
              >
                Sign in from desktop
              </Typography>
              <Grid>
                <img
                  alt=""
                  style={{ padding: 10, marginTop: 16, height: 80 }}
                  src={logo}
                />
              </Grid>
            </div>
          </Container>
        </Grid>
        <Grid style={{ width: "100%", marginTop: "2%" }}>
          <BottomBar />
        </Grid>
        <Dialog open={this.state.open} style={{ width: "100%" }}>
          <DialogTitle id="alert-dialog-title">{"Notice"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {
                "Hello Company Community member, this feature is only available on a desktop and cannot be accessed via our mobile site. In order to sign in, please visit our website on your desktop and you will be granted access to your profile.\n\nThank you, CanaWho."
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleClose()}
              color="primary"
              autoFocus
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

LogIn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LogIn);
